import * as types from "../actions/actiontype";
import * as appUtilityFunction from '../../../infrastructure/apputilityfunctions'

const initialState = {
  
}
initialState.dashboardConfig={
  repDashboard: null,
  canShowCreateDashboard: false,
  canShowBtnCreate: false,
  canShowBtnSave: false,
  dashboardId: null,
  dashboardName: null,
  dashboardType: null,
  dashboardQuery: null,
  dashboardTypes : [
          { id: 1, title: 'Pie Chart' },
          { id: 2, title: 'Bar Chart' },
          { id: 3, title: 'Line Chart' },
          { id: 4, title: 'Card' },
          { id: 5, title: 'Doughnut Chart' },
          { id: 6, title: 'Table' },
          { id: 7, title: 'List' }
      ],

}

export default function policyReducer(state = initialState, action) {
    switch (action.type) {
        
        case types.GET_REP_DASBOARD_END: {
            return {
              ...state,
              dashboardConfig: {
                ...state.dashboardConfig,
                repDashboard: action.payload
              }
            };
          }
        case types.CREATE_DASHBORD: {
          return {
            ...state,
            dashboardConfig: {
                ...state.dashboardConfig,
                canShowCreateDashboard: true,
                canShowBtnSave: true
            }
          }
        }
        default:
            return state;
    }
}